/* esm.sh - applesauce-common@5.2.0/blueprints */
export * from "/*applesauce-common@5.2.0/esnext/blueprints.mjs";
